export default __webpack_public_path__ + "static/media/StatusPending.d3d02548.png";